// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_in-7";
export var emphasizeQuantity = "_in-3";
export var flatBottomCorners = "_in-5";
export var productImage = "_in-0";
export var quantityContainer = "_in-2";
export var quantityHeader = "_in-6";
export var tooltip = "_in-1";
export var wrapAndEllipsesOverflow = "_in-4";